import { Navigate, NavLink, Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { firstVisibleHousePath, resolveTeamPath } from '@/application/navigation/menuHouses';
import { usePermissions } from '@/presentation/contexts/permissionsContextCore';

/** Shell compartido: tabs Usuarios | Roles bajo Equipo. */
export function TeamLayout() {
  const { t } = useTranslation();
  const { hasPermission, isOwner, isSimulating } = usePermissions();
  const canManageTeam = isOwner && !isSimulating;
  const canUsers = canManageTeam;
  const canRoles = canManageTeam;

  if (!canUsers && !canRoles) {
    return <Navigate to={firstVisibleHousePath(hasPermission) ?? '/'} replace />;
  }

  const tabClass = ({ isActive }: { isActive: boolean }) =>
    `rounded-md px-3 py-1.5 text-sm font-semibold transition ${
      isActive
        ? 'bg-teal-600 text-white'
        : 'text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-gray-800'
    }`;

  return (
    <div className="panel-page panel-safe-bottom">
      <div>
        <h1 className="text-2xl font-bold text-gray-950 dark:text-white">{t('team.title')}</h1>
        <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">{t('team.description')}</p>
      </div>

      <nav aria-label={t('team.tabsLabel')} className="flex flex-wrap gap-2 border-b border-gray-200 pb-3 dark:border-gray-800">
        {canUsers && (
          <NavLink to="/team/assistants" className={tabClass} end>
            {t('team.tabs.users')}
          </NavLink>
        )}
        {canRoles && (
          <NavLink to="/team/roles" className={tabClass} end>
            {t('team.tabs.roles')}
          </NavLink>
        )}
      </nav>

      <Outlet />
    </div>
  );
}

/** Índice `/team` → Usuarios (o Roles si no hay permiso de asistentes). */
export function TeamIndexRedirect() {
  const { hasPermission, isOwner, isSimulating } = usePermissions();
  if (!isOwner || isSimulating) {
    return <Navigate to={firstVisibleHousePath(hasPermission) ?? '/'} replace />;
  }
  const teamPath = resolveTeamPath(hasPermission);
  if (teamPath !== '/team') {
    return <Navigate to={teamPath} replace />;
  }
  return <Navigate to={firstVisibleHousePath(hasPermission) ?? '/'} replace />;
}
